import {
  SET_PAYMENT_RECEIPT,
  SET_SPECIFIC_PAYMENT_RECEIPT,
  SET_BALANCE,
  SET_PENDING_PURCHASES,
} from "../Types/PaymentReceiptTypes";

const initialState = {
  allPaymentReceipt: [],
  specificPaymentReceipt: {},
  pendingPurchases: [],
  vendorBalance: {},
};

const PaymentReceiptReducer = (state = initialState, action) => {
  if (action.type === SET_PAYMENT_RECEIPT) {
    return { ...state, allPaymentReceipt: action.payLoad };
  } else if (action.type === SET_SPECIFIC_PAYMENT_RECEIPT) {
    return { ...state, specificPaymentReceipt: action.payLoad };
  } else if (action.type === SET_BALANCE) {
    return { ...state, vendorBalance: action.payLoad };
  } else if (action.type === SET_PENDING_PURCHASES) {
    return { ...state, pendingPurchases: action.payLoad };
  } else {
    return state;
  }
};

export default PaymentReceiptReducer;
